import { Trans } from '@lingui/react'
import React from 'react'
import Grid, { Cell, Row } from '../Grid'

declare module 'react' {
  interface HTMLAttributes<T> extends AriaAttributes, DOMAttributes<T> {
    xmlns?: string
  }
}

export const Container = ({ children }) => {
  return (
    <html xmlns="http://www.w3.org/1999/xhtml">
      <head>
        <meta name="viewport" content="width=device-width" />
        <meta charSet="utf-8" />
        <style
          dangerouslySetInnerHTML={{
            __html: 'p {overflow-wrap: break-word;}'
          }}
        />
      </head>
      <body
        style={{
          backgroundColor: '#eff2f3',
          width: '100% !important',
          margin: 0,
          padding: 0
        }}
      >
        <Grid
          bgcolor="#eff2f3"
          style={{
            backgroundColor: '#eff2f3',
            fontSize: '16px'
          }}
        >
          <Row>
            <Cell bgcolor="#eff2f3">&nbsp;</Cell>
          </Row>
          <Row>
            <Cell>
              <Grid>
                <Row>
                  <Cell>&nbsp;</Cell>
                  <Cell
                    bgcolor="#eff2f3"
                    width="600" // use cell width as MSO does not support max-width CSS //
                    align="center"
                    style={{
                      fontFamily: 'Helvetica, Arial, sans-serif',
                      padding: '16px'
                    }}
                  >
                    <Grid
                      style={{
                        backgroundColor: 'white',
                        borderRadius: '8px'
                      }}
                    >
                      {children}
                      <Row>
                        <Cell
                          style={{
                            padding: '0 16px 16px'
                          }}
                        >
                          &nbsp;
                        </Cell>
                      </Row>
                    </Grid>
                  </Cell>
                  <Cell>&nbsp;</Cell>
                </Row>
              </Grid>
            </Cell>
          </Row>
          <Row>
            <Cell bgcolor="#eff2f3">
              <p
                style={{
                  fontFamily: 'Helvetica,Arial,sans-serif',
                  fontSize: '13px',
                  color: '#B1BfC5',
                  lineHeight: '24px',
                  textAlign: 'center',
                  padding: '40px'
                }}
              >
                <Trans id="Powered by" />
                &nbsp;
                <a
                  style={{
                    color: '#B1BfC5',
                    textDecoration: 'underline'
                  }}
                  href="https://www.looop.co"
                >
                  Looop
                </a>
                .
              </p>
            </Cell>
          </Row>
        </Grid>
      </body>
    </html>
  )
}
